import { ShieldCheck } from '@phosphor-icons/react';

/**
 * The named guarantee, in the shape StubHub uses for FanProtect: a marked tile,
 * a titled promise, and the detail beneath it. A named thing reads as a policy;
 * the same words as a grey line under a card read as small print.
 *
 * Sits on the page background as its own block, not inside a white section —
 * it is a promise about the whole purchase, not a row of one.
 *
 * `#34C759` is CL-1's systemGreen. At 12% over white the tile lands near
 * #E2F7E8, which is why the glyph carries the full-strength colour and
 * `weight="bold"`: CL-1 records that these hues are tuned for SF Symbols and
 * render light at a thin Phosphor stroke.
 */
export default function GuaranteeBlock({
  title = 'Satisfaction Guarantee',
  body = 'Not satisfied after the first lesson of the program? Full refund, no questions asked.',
  className = '',
}: {
  title?: string;
  body?: string;
  className?: string;
}) {
  return (
    <div className={`flex items-start ${className}`} style={{ gap: 12 }}>
      <div
        className="flex items-center justify-center flex-shrink-0"
        style={{ width: 36, height: 36, borderRadius: 8, background: 'rgba(52,199,89,0.12)' }}
      >
        <ShieldCheck size={20} weight="bold" color="#34C759" aria-hidden="true" />
      </div>
      <div className="min-w-0">
        <div className="text-[15px] leading-[20px] font-semibold text-[#1C1C1C]">{title}</div>
        <div className="text-[13px] leading-[18px] text-[rgba(60,60,67,0.6)]">{body}</div>
      </div>
    </div>
  );
}
